import React, { useState } from 'react';
import { components } from 'generated/payment-initialisation/schema';
import { TCountries } from 'models/countries';

import { CurrencyList } from '@alpha/bene-dtos';

import RemitterDrawer from './RemitterDrawer/RemitterDrawer';
import RemittersTable from './RemittersTable/RemittersTable';

interface IRemittersProps {
    remitters: components['schemas']['RemittersListResponse'];
    refetchRemitters: () => Promise<void>;
    isLoading: boolean;
    activeTab: string;
    setActiveTab: (tab: string) => void;
    setSearchQuery: (query: string) => void;
    searchQuery: string;
    setPageNumber: (prevPageNumber: (prevPageNumber: number) => number) => void;
    pageNumber: number;
    countries: TCountries;
    currencies: CurrencyList;
}

const Remitters: React.FC<IRemittersProps> = ({
  remitters,
  refetchRemitters,
  isLoading,
  activeTab,
  setActiveTab,
  setSearchQuery,
  searchQuery,
  setPageNumber,
  pageNumber,
  countries,
  currencies,
}) => {
  const [openCreateRemitterDrawer, setOpenCreateRemitterDrawer] = useState(false);
  const [editRemitterId, setEditRemitterId] = useState<string | undefined>(undefined);

  return (
    <>
      <div style={{ marginTop: '12px' }}>
        <RemittersTable
          data={remitters}
          setOpenCreateRemitterDrawer={setOpenCreateRemitterDrawer}
          setEditRemitterId={setEditRemitterId}
          isLoading={isLoading}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          setSearchQuery={setSearchQuery}
          searchQuery={searchQuery}
          setPageNumber={setPageNumber}
          pageNumber={pageNumber}
        />
      </div>
      {openCreateRemitterDrawer ? (
        <RemitterDrawer
          open={openCreateRemitterDrawer}
          handleClose={() => {
            setOpenCreateRemitterDrawer(false);
            setEditRemitterId(undefined);
          }}
          refetchRemitters={refetchRemitters}
          editRemitterValues={editRemitterId ? remitters?.Remitters?.find((r) => r.Id === editRemitterId) : undefined}
          countries={countries}
          currencies={currencies}
        />
      ) : null}
    </>
  );
};

export default Remitters;
